var feedbackData = { appId: 50154 };
export var InAppFeedbackInit = (function () {
    var register = function (listener) {
        if (listener) {
            listeners.push(listener);
        }
        return feedbackData;
    };
    var unregister = function (listener) {
        var index = listeners.indexOf(listener);
        if (index > -1) {
            listeners.splice(index, 1);
        }
    };
    var listeners = [];
    var updateFeedbackObject = function (updatedInAppFeedbackInitOptions) {
        Object.assign(feedbackData, updatedInAppFeedbackInitOptions);
        listeners.forEach(function (listener) { return listener(feedbackData); });
    };
    var configObject = {
        register: register,
        unregister: unregister,
        updateFeedbackObject: updateFeedbackObject
    };
    return configObject;
})();
//# sourceMappingURL=InAppFeedbackInit.js.map